window.setLocationCity = function(data){
  var target = ".location-search input";
  $(target).val(data);
}
function clickCallStore(store){
  var ga = window.ga;
  ga('send', 'event', 'Store Finder Call', 'Click', store);
}
function clickWebsiteStore(store){
  var ga = window.ga;
  ga('send', 'event', 'Store Finder Website', 'Click', store);
}
function clickDirectionsStore(store){
  var ga = window.ga;
  ga('send', 'event', 'Store Finder Directions', 'Click', store);
}
google.maps.event.addDomListener(window, 'load', function() {
  var map = new google.maps.Map(document.getElementById('map-canvas'), {
    center: new google.maps.LatLng(-28, 135),
    zoom: 4,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles:[
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#212121"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#212121"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#181818"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#1b1b1b"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#2c2c2c"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#8a8a8a"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#373737"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#3c3c3c"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#4e4e4e"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#3d3d3d"
          }
        ]
      }
    ]
  });

  var panelDiv = document.getElementById('panel');

  var data = new StoreDataSource;


  if(window.location.href.indexOf("stores") > -1){
    var view = new storeLocator.View(map, data, {
      geolocation: true,
      features: data.getFeatures(),
      markerIcon: 'https://cdn.shopify.com/s/files/1/2024/3957/files/revit-pin_35x.png?5715'
    });
  } else {
    var view = new storeLocator.View(map, data, {
      geolocation: false,
      features: data.getFeatures(),
      markerIcon: 'https://cdn.shopify.com/s/files/1/2024/3957/files/revit-pin_35x.png?5715'
    });
  }


  var mainPanel = new storeLocator.Panel(panelDiv, {
    view: view,
    locationSearchLabel: ''
  });

  view.addListener('selectedStore_changed',function(){
    var target = "#panel";
    if($(target).hasClass('list-shown')){
      $('#panel').removeClass('list-shown');
      $('#panel .btn').text('list');
    }
   
  })
  view.addListener('geolocate',function(){
    console.log('locate');
   
  })
});


/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
function StoreDataSource() {
  $.extend(this, new storeLocator.StaticDataFeed);

  var that = this;
  $.get(window.REVIT_WORKER_URL + '/sheets/1WcHEsAaRZYTBJCOQ1vEsVTvvmNuhkBBbIgjxm6jlbtQ?ranges=A1:Z1000', function(data) {
    var csv = '';  
    for (i = 0; i < data.valueRanges['0'].values.length; i++) { 
      var cellData = [];
      for (x = 0; x < data.valueRanges['0'].values[i].length; x++) {
        cellData[x] = data.valueRanges['0'].values[i][x].replace(',', ';');
      }
      csv += cellData + '\n';
    }   
    that.setStores(that.parse_(csv));
  });
}
  
  /**
   * @const
   * @type {!storeLocator.FeatureSet}
   * @private
   */
  StoreDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet();
  
  /**
   * @return {!storeLocator.FeatureSet}
   */
  StoreDataSource.prototype.getFeatures = function() {
    return this.FEATURES_;
  };
  
  /**
   * @private
   * @param {string} csv
   * @return {!Array.<!storeLocator.Store>}
   */
  StoreDataSource.prototype.parse_ = function(csv) {
    var stores = [];
    var rows = csv.split('\n');
    var headings = this.parseRow_(rows[0]);
    for (var i = 1; i < rows.length; i++) {
  
      var singleCell = rows[i].split(',');
      var singleHead = headings[0].split(',');
      var singleObject = {};
        for (var x = 0; x < singleHead.length; x++) {
          if(singleCell[x] != null && singleCell[x] != '' ){
            var cleanCell = singleCell[x].replace(";", ",")
            var cleanHeader = singleHead[x].replace(/(\r\n|\n|\r)/gm, "");
            singleObject[cleanHeader] = cleanCell;
          }
        }
      
      var position = new google.maps.LatLng(singleObject.Latitude,singleObject.Longitude);
      var street = this.join_([singleObject.Shop_Number, singleObject.Shop_Street],' ');
      var shop = this.join_([street , singleObject.Shop_City], ', ');
      var locality = this.join_([singleObject.Shop_State, singleObject.Shop_Postcode], ', ');
      var website = new storeLocator.Feature('1', '<a class="store-website"  onclick="clickWebsiteStore(\''+ singleObject.Shop_Name +'\')"  target="_blank" href="'+ singleObject.Website +'">' + singleObject.Website + '</a>');
      var callus = new storeLocator.Feature('2', '<a class="store-callus" href="tel:'+ singleObject.Phone_Number +'" onclick="clickCallStore(\''+ singleObject.Shop_Name +'\')"><button class="btn btn-main w-100">Call us</button></a>');
      var directions = new storeLocator.Feature('3', '<a class="store-directions"  onclick="clickDirectionsStore(\''+ singleObject.Shop_Name +'\')" href="https://www.google.com/maps/search/?api=1&query='+ shop.split(' ').join('+') + ',' + locality.split(' ').join('+') +'" onclick="clickDirectionStore(\''+ singleObject.Shop_Name +'\')" target="_blank"><button class="btn btn-main w-100">Directions</button></a>');
      //var features = new storeLocator.FeatureSet(callus,directions);
      var features = new storeLocator.FeatureSet(website, directions, callus);
      if (singleObject.Phone_Number == null){
        var isTelHidden = 'd-none';
      } else {
        var isTelHidden = '';
      }
      
      var store = new storeLocator.Store(i, position, features, {
        title: singleObject.Shop_Name,
        address: this.join_([shop, locality], '<br>'),
        phone: '<a href="tel:'+ singleObject.Phone_Number +'" onclick="clickCallStore(\''+ singleObject.Shop_Name +'\')" class="'+ isTelHidden +'">' + singleObject.Phone_Number + '</a>'      });
      if(singleObject.Shop_Name){
        stores.push(store);
      }
    }
  
    return stores;
  
    };
  
  /**
   * Joins elements of an array that are non-empty and non-null.
   * @private
   * @param {!Array} arr array of elements to join.
   * @param {string} sep the separator.
   * @return {string}
   */
  StoreDataSource.prototype.join_ = function(arr, sep) {
    var parts = [];
    for (var i = 0, ii = arr.length; i < ii; i++) {
      arr[i] && parts.push(arr[i]);
    }
    return parts.join(sep);
  };
  
  /**
   * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
   * IMPORTANT: Don't use this for general CSV parsing!
   * @private
   * @param {string} row
   * @return {Array.<string>}
   */
  StoreDataSource.prototype.parseRow_ = function(row) {
    // Strip leading quote.
    if (row.charAt(0) == '"') {
      row = row.substring(1);
    }
    // Strip trailing quote. There seems to be a character between the last quote
    // and the line ending, hence 2 instead of 1.
    if (row.charAt(row.length - 2) == '"') {
      row = row.substring(0, row.length - 2);
    }
  
    row = row.split('","');
  
    return row;
  };
  
  /**
   * Creates an object mapping headings to row elements.
   * @private
   * @param {Array.<string>} headings
   * @param {Array.<string>} row
   * @return {Object}
   */
  StoreDataSource.prototype.toObject_ = function(headings, row) {
    var result = {};
    for (var i = 0, ii = row.length; i < ii; i++) {
      result[headings[i]] = row[i];
    }
    return result;
  };